import React from 'react';
import PropTypes from 'prop-types';
import Actions from './Actions';

class GroupItem extends React.Component {
  render() {
    const { data, onAction } = this.props;
    const { id, name, locations } = data;
    const locationsStr = locations.map(item => item.name).join(', ');

    return (
      <tr>
        <td>{name}</td>

        <td>{locationsStr}</td>

        <td style={{width: '150px'}}>
          <Actions id={id} onAction={onAction} />
        </td>
      </tr>
    );
  }
}

GroupItem.propTypes = {
  data: PropTypes.object.isRequired,
  onAction: PropTypes.func
};

export default GroupItem;
